import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Typography,
  Form,
  Input,
  Button,
  Spin,
  notification,
  Row,
  Col,
  theme,
} from "antd";
import UserApi from "../common/Apis/UserApi";
import RegisterForm from "../common/CommonUI/RegisterForm/RegisterForm";

const { Title } = Typography;
const ForgotPassword = (props) => {
  const { useToken } = theme;
  const { token } = useToken();
  const [loadings, setLoadings] = useState(false);
  const handleSubmit = (data) => {
    setLoadings(true);
    // Change Password Api
    const formData = new FormData();
    formData.append("email", data.email);

    UserApi.resetPassword(formData)
      .then((response) => {
        setLoadings(false);
        console.log(response.payload);
        notification.open({
          message: (
            <span style={{ fontWeight: "bold" }}>{response.resultStatus}</span>
          ),
          description: response.payload,
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
      })
      .catch((err) => {
        setLoadings(false);
        // Error Notification
        console.log(err.apiError.status);
        if (err) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#ffb3b3",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <>
      <div className="container container-body form-container">
        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-9 col-md-9 content-border my-5">
            <Row gutter={24}>
              <RegisterForm />
              <Col
                lg={12}
                md={24}
                className="py-4"
                style={{ boxShadow: "8px 8px 16px -4px rgba(0, 0, 0, 0.1)" }}
              >
                <Form
                  name="nest-messages"
                  layout="vertical"
                  onFinish={handleSubmit}
                  className="py-3 px-4 Register-form"
                >
                  <div className="d-flex justify-content-center pb-4">
                    <img
                      src="/assest/Images/Logo/logo.png"
                      className="logo-png"
                    />
                  </div>

                  <Title
                    style={{
                      textAlign: "center",
                      color: "black",
                      marginBottom: 30,
                    }}
                    level={4}
                    className="Primary-Font"
                  >
                    Forgot Password
                  </Title>

                  <>
                    <p className="text-center" style={{ fontSize: "12px" }}>
                      Please enter your email to get the password reset link
                    </p>
                    <Form.Item
                      name="email"
                      className="text-lable"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "The input is not valid E-mail!",
                        },
                      ]}
                    >
                      <Input
                        type="text"
                        className="form-control control-input"
                        placeholder="Enter your email"
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="btn btn-primary mt-0 mb-2 w-100"
                      disabled={loadings == true}
                      style={{ background: token.colorPrimary }}
                    >
                      Reset Password{" "}
                      {loadings == true && <Spin className="px-2" />}
                    </Button>
                    <p className="content signup-content py-4 my-5">
                      Already a member?{" "}
                      <Link to={"/"} className="content-link">
                        Sign In
                      </Link>
                    </p>
                  </>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
